import { Box, Skeleton, Stack, Card } from '@mui/material';

interface LoadingStateProps {
  /** How many skeleton rows/cards to render. */
  count?: number;
  /** 'list' = stacked rows, 'cards' = grid of cards, 'lines' = text lines. */
  variant?: 'list' | 'cards' | 'lines';
}

/**
 * Skeleton placeholders shown while data loads, so pages never flash blank.
 */
const LoadingState = ({ count = 4, variant = 'list' }: LoadingStateProps) => {
  if (variant === 'lines') {
    return (
      <Stack spacing={1} sx={{ py: 1 }}>
        {Array.from({ length: count }).map((_, i) => (
          <Skeleton key={i} variant="text" width={`${90 - i * 8}%`} height={22} />
        ))}
      </Stack>
    );
  }

  if (variant === 'cards') {
    return (
      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
        }}
      >
        {Array.from({ length: count }).map((_, i) => (
          <Card key={i} sx={{ p: 2 }}>
            <Skeleton variant="rounded" height={120} sx={{ mb: 1.5, borderRadius: 2 }} />
            <Skeleton variant="text" width="70%" height={26} />
            <Skeleton variant="text" width="45%" />
          </Card>
        ))}
      </Box>
    );
  }

  return (
    <Stack spacing={1.5}>
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i} sx={{ p: 2 }}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Skeleton variant="circular" width={44} height={44} />
            <Box sx={{ flexGrow: 1 }}>
              <Skeleton variant="text" width="55%" height={22} />
              <Skeleton variant="text" width="35%" />
            </Box>
            <Skeleton variant="rounded" width={64} height={30} sx={{ borderRadius: 999 }} />
          </Stack>
        </Card>
      ))}
    </Stack>
  );
};

export default LoadingState;
